import { Group } from '@melio/penny';
import { Vendor } from '@melio/platform-api';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { Currency } from '@melio/platform-i18n';
import { forwardRef } from '@melio/platform-utils';

import { EditableScreenTitle } from './EditableScreenTitle';
import { NonEditableScreenTitle } from './NonEditableScreenTitle';

type FundingSourceSelectionScreenTitleProps = {
  vendorName: Vendor['name'];
  paymentAmount: number;
  currency?: Currency;
  onChangePaymentAmount?: (newAmount: number) => void;
  billBalance?: number;
  minimumAmount?: number;
  shouldAllowEditAmount?: boolean;
  onError?: VoidFunction;
  isRecurringPayment?: boolean;
};

export const FundingSourceSelectionScreenTitle = forwardRef<FundingSourceSelectionScreenTitleProps>(
  (
    {
      vendorName,
      paymentAmount,
      currency,
      isRecurringPayment,
      onChangePaymentAmount,
      billBalance,
      minimumAmount,
      shouldAllowEditAmount,
      onError,
      ...props
    },
    ref
  ) => {
    const [isPartialPaymentsEnabled] = useFeature<boolean>(FeatureFlags.PartialPaymentsEnabled, false);

    return (
      <Group variant="vertical" alignItems="center" {...props} ref={ref}>
        {isPartialPaymentsEnabled && shouldAllowEditAmount && billBalance ? (
          <EditableScreenTitle
            vendorName={vendorName}
            paymentAmount={paymentAmount}
            currency={currency}
            onChangePaymentAmount={onChangePaymentAmount}
            billBalance={billBalance}
            minimumAmount={minimumAmount}
            onError={onError}
          />
        ) : (
          <NonEditableScreenTitle
            vendorName={vendorName}
            paymentAmount={paymentAmount}
            currency={currency}
            isRecurringPayment={isRecurringPayment}
          />
        )}
      </Group>
    );
  }
);
